export function BinLookupApiConfigEditor() {
    return (
        <p className="text-sm text-muted-foreground">
            Uses the environment-managed binlookupapi credential. The API key is never stored in
            merchant configuration.
        </p>
    );
}
